import { MatTableDataSource } from "@angular/material/table";
import { Bien } from "../models/Bien";


export enum DataStateEnum {
    LOADING,
    LOADED,
    ERROR,
}

export interface AppState<T> {
    dataStatut?: DataStateEnum,
    data?: T,
    errorMessage?: string,
    dataSource?: MatTableDataSource<any>;

}